import React from 'react';
import connectImage from '../../assets/icons/connect.svg';
import intl from '../../locale';
import { ErrorOverlay } from '../ErrorOverlay';

interface ConnectionErrorOverlayProps {
  onRetry: () => void;
  isLoading?: boolean;
  isWebview: boolean;
  retryCount?: number;
}

export const ConnectionErrorOverlay: React.FC<ConnectionErrorOverlayProps> = ({
  onRetry,
  isLoading,
  isWebview,
  retryCount = 0,
}) => {
  const isFirstRetry = retryCount === 0;

  const title = isFirstRetry
    ? intl.formatMessage({ id: 'System.AnswerSendErrorFirstTitle' })
    : intl.formatMessage({ id: 'System.AnswerSendErrorSecondTitle' });

  const description = isFirstRetry
    ? intl.formatMessage({ id: 'System.AnswerSendErrorFirstDescription' })
    : intl.formatMessage({ id: 'System.AnswerSendErrorSecondDescription' });

  return (
    <ErrorOverlay
      isWebview={isWebview}
      isLoading={isLoading}
      image={connectImage}
      title={title}
      description={description}
      animate={!isFirstRetry}
      onClick={onRetry}
      buttonText={intl.formatMessage({ id: 'System.AnswerSendErrorRetry' })}
    />
  );
};

export default ErrorOverlay;
